import React, { useState } from 'react';
import {
  Box,
  Grid,
  Area,
  useTheme,
  Text,
  Separator,
  Typography,
} from '@ublend-npm/aulaui-core';
import { useMediaQuery } from '@mui/material';

import changeUserStatus from '@core/actions/user/status';
import { isChangingStatus } from '@core/selectors/user';
import { useDispatch, useSelector, useStore } from 'react-redux';
import StatusInput from './StatusInput';
import StatusButtons from './StatusButtons';
import ProfileUpdate from './ProfileUpdate.container';

const AccountDetails = ({ route }: any) => {
  const { palette, breakpoints } = useTheme();

  const store = useStore();
  const dispatch = useDispatch();
  const isDesktop = useMediaQuery(breakpoints.up('md'));
  const user = useSelector(
    // eslint-disable-next-line no-undef
    (state: ReturnType<typeof store.getState>) => state?.user.user
  );
  const status = useSelector(
    // eslint-disable-next-line no-undef
    (state: ReturnType<typeof store.getState>) => state.user.user.status
  );
  const isSaving = useSelector(isChangingStatus);

  const initialStatusText = status?.text || '';
  const initialEmojiShortName = status?.emojiName || '';

  const [statusText, setStatusText] = useState(initialStatusText);
  const [emojiShortName, setEmojiShortName] = useState(initialEmojiShortName);

  const setStatus = () => {
    const data = {
      status: {
        text: statusText,
        emojiName: emojiShortName,
      },
    };
    dispatch(changeUserStatus(data));
  };

  return (
    <Box
      bgcolor={palette.background.default}
      sx={{ minHeight: '100dvh' }}
      id="content-container"
    >
      <Grid container maxWidth="75rem" margin="0 auto">
        {isDesktop && (
          <Grid size={{ xs: 12, sm: 12, md: 3, lg: 3 }}>
            {route.profileMenu()}
          </Grid>
        )}
        {/* Container Area */}
        <Grid
          size={{ xs: 12, sm: 12, md: 9, lg: 9 }}
          padding={{
            xs: '1.5rem 1rem',
            sm: '1.5rem 1.5rem',
            md: '2.5rem 1.5rem',
            lg: '2.5rem 1.5rem',
          }}
        >
          <Area sx={{ borderRadius: '8px', paddingX: '24px' }}>
            <Box
              sx={{
                marginTop: '14px',
                display: 'flex',
                justifyContent: 'space-between',
                backgroundColor: palette.background.paper,
              }}
            >
              <Typography tabIndex={0} sx={{ fontSize: '1.5rem' }}>
                {' '}
                Account details{' '}
              </Typography>
              <StatusButtons
                initialStatusText={initialStatusText}
                initialEmojiShortName={initialEmojiShortName}
                statusText={statusText}
                emojiShortName={emojiShortName}
                onSave={setStatus}
                isSaving={isSaving}
              />
            </Box>
            <Separator sx={{ my: '24px' }} />
            <Box
              sx={{
                display: 'flex',
                flexDirection: {
                  xs: 'column',
                  sm: 'row',
                },
                alignItems: {
                  xs: 'flex-start',
                  sm: 'center',
                },
                gap: '16px',
              }}
            >
              <ProfileUpdate />
              <Box sx={{ maxWidth: '100%', height: 'auto' }}>
                <Text sx={{ fontSize: '1.25rem', fontWeight: '600' }}>
                  {user.firstName} {user.lastName}
                </Text>
                <Text
                  sx={{
                    fontSize: '0.875rem',
                    color: palette.mode === 'dark' ? '#FFFFFF' : '#000000DE',
                  }}
                >
                  {user.email}
                </Text>
              </Box>
            </Box>
            <Box
              sx={{
                marginTop: '14px',
                marginBottom: '32px',
                width: {
                  xs: '100%',
                  sm: '100%',
                  md: '100%',
                  lg: '80%',
                  xl: '80%',
                },
                position: 'relative',
              }}
            >
              <StatusInput
                statusText={statusText}
                emojiShortName={emojiShortName}
                setStatusText={setStatusText}
                setEmojiShortName={setEmojiShortName}
              />
              <Typography
                sx={{
                  position: 'absolute',
                  color: palette.text.secondary,
                  top: '60px',
                  fontWeight: '400',
                  fontSize: '0.75rem',
                  letterSpacing: '0.4px',
                  padding: '8px',
                  lineHeight: '140%',
                }}
                tabIndex={0}
              >
                Write something about you, your availability, or your preferred
                ways to be contacted. Your status is viewable by everyone in
                Aula.
              </Typography>
            </Box>
          </Area>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AccountDetails;
